module.exports = __webpack_public_path__ + "static/media/news.9b2091bd.svg";